// extracted by mini-css-extract-plugin
module.exports = {"compWrap":"JobInfoTagsSection_compWrap__EPZtk","icon":"JobInfoTagsSection_icon__KUYp_"};